import type { Metrics, SortAlgorithm } from '@/core/types';
import { Colors } from '@/styles/colors';

interface MetricsPanelProps {
  metrics: Metrics;
  algorithm: SortAlgorithm;
}

export function MetricsPanel({ metrics, algorithm }: MetricsPanelProps) {
  const formatValue = (v: number): string => v >= 1000 ? `${(v / 1000).toFixed(1)}K` : `${v}`;

  const rows = [
    { label: 'Perbandingan', value: formatValue(metrics.comparisons), color: Colors.status.comparing },
    { label: 'Pertukaran', value: formatValue(metrics.swaps), color: Colors.status.swapping },
    { label: 'Penulisan', value: formatValue(metrics.overwrites), color: Colors.status.selected },
    { label: 'Akses array', value: formatValue(metrics.arrayAccesses), color: Colors.light.text },
    { label: 'Kedalaman rekursi', value: formatValue(metrics.recursionDepth), color: Colors.light.primary },
    { label: 'Langkah', value: formatValue(metrics.eventCount), color: Colors.light.text },
    { label: 'Estimasi memori', value: `${formatValue(metrics.memoryEstimate)}`, color: Colors.light.text },
  ];

  return (
    <div style={{
      backgroundColor: Colors.light.surface,
      border: `1px solid ${Colors.light.border}`,
      borderRadius: 8, padding: 20, flex: 1, minWidth: 0,
    }}>
      <h2 style={{ margin: '0 0 16px', color: Colors.light.primary, fontSize: 16 }}>Ringkasan proses</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: 8 }}>
        {rows.map(r => (
          <div key={r.label} style={{ padding: '8px 10px', backgroundColor: Colors.light.background, borderRadius: 4 }}>
            <div style={{ fontSize: 11, color: Colors.light.textSecondary }}>{r.label}</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: r.color }}>{r.value}</div>
          </div>
        ))}
      </div>
      <div style={{ marginTop: 16, padding: 10, backgroundColor: Colors.light.background, borderRadius: 4 }}>
        <div style={{ fontSize: 11, color: Colors.light.textSecondary, marginBottom: 8 }}>Kompleksitas</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, fontSize: 12 }}>
          <div><div style={{ color: Colors.light.textSecondary }}>Terbaik</div><div style={{ color: Colors.light.text }}>{algorithm.best}</div></div>
          <div><div style={{ color: Colors.light.textSecondary }}>Rata-rata</div><div style={{ color: Colors.light.text }}>{algorithm.average}</div></div>
          <div><div style={{ color: Colors.light.textSecondary }}>Terburuk</div><div style={{ color: Colors.light.text }}>{algorithm.worst}</div></div>
        </div>
        <div style={{ marginTop: 8, fontSize: 11, color: Colors.light.textSecondary }}>
          Ruang: {algorithm.space}
        </div>
      </div>
    </div>
  );
}
